import React from 'react';
import PropTypes from 'prop-types';
import unorm from 'unorm';
import moment from 'moment';

const colorSeverity = (arr, type) => {
  // formatting process to be able to find the element in the array
  let str = type;
  str = unorm.nfd(str).replace(/[\u0300-\u036f]/g, '');
  str = str.toLowerCase();
  const obj = arr.find(o => o.key === str);
  if (obj) {
    return obj.color;
  }
  return '#000000';
};

// condition to edit date displayed in table
const dateSelect = (item, type) => {
  if (type === 1 || type === '1') {
    return moment(item.creationDate.substring(0, 19)).format('DD-MM-YY H:mm:ss');
  } else if (type === 2 || type === '2') {
    return moment(item.mobileDate.substring(0, 19)).format('DD-MM-YY H:mm:ss');
  }
};

// valid if we have fails
const validateFails = arr => {
  let num = 0;
  arr.forEach(item => {
    num += item.value;
  });
  return num !== 0;
};

const translate = (arr, type, language) => {
  // formatting process to be able to find the element in the array
  let str = type;
  str = unorm.nfd(str).replace(/[\u0300-\u036f]/g, '');
  str = str.toLowerCase();
  const obj = arr.find(o => o.key === str);
  return obj ? obj[`${language}Name`] : '';
};

// valid if the item has value
const validateFailsCount = (val, arr, language) => {
  if (val.value > 0) {
    return `${translate(arr, val.severityType, language)} (${val.value})`;
  }
  return '';
};
const Table = props => (
  <div className="module-table top">
    <table>
      <thead>
        <tr>
          {props.tableDate === 1 && (
            <th className="th100 left pd-left">
              <a
                role="button"
                data-type={props.main === '1' ? 'creationDate' : 'mobileDate'}
                tabIndex={0}
                onClick={props.handleSort}
              >
                {props.language.filter.date} <i className="fas fa-arrows-alt-v" />
                <br />
                {props.main === '1' ? ' sincronización' : 'inspección'}
              </a>
            </th>
          )}
          {props.tableDate === 2 && (
            <th className="th100 left pd-left">
              <a role="button" data-type={'creationDate'} tabIndex={0} onClick={props.handleSort}>
                {props.language.filter.date} <i className="fas fa-arrows-alt-v" />
                <br />
                sincronización
              </a>
            </th>
          )}
          {props.tableDate === 2 && (
            <th className="th100 left pd-left">
              <a role="button" data-type={'mobileDate'} tabIndex={0} onClick={props.handleSort}>
                {props.language.filter.date} <i className="fas fa-arrows-alt-v" />
                <br />
                Inspección
              </a>
            </th>
          )}
          <th className="left">{props.language.filter.inspector}</th>
          <th>
            <a role="button" data-type="score" tabIndex={0} onClick={props.handleSort}>
              {props.language.filter.note} <i className="fas fa-arrows-alt-v" />
            </a>
          </th>
          <th className="left">{props.language.filter.type}</th>
          <th className="left">{props.language.filter.form}</th>
          <th className="left">{props.language.filter.driver}</th>
          <th className="left">{props.language.filter.team}</th>
          <th className="left">
            <a role="button" data-type="fails" tabIndex={0} onClick={props.handleSort}>
              {props.language.filter.fails} <i className="fas fa-arrows-alt-v" />
            </a>
          </th>
          {props.filterQuestion.filterQuestion1Value.state && (
            <th className="left">
              {props.filterQuestion.filterQuestion1Value[`${props.languageFormat}`]}
            </th>
          )}
          {props.filterQuestion.filterQuestion2Value.state && (
            <th className="left">
              {props.filterQuestion.filterQuestion2Value[`${props.languageFormat}`]}
            </th>
          )}
          {props.filterQuestion.filterQuestion3Value.state && (
            <th className="left">
              {props.filterQuestion.filterQuestion3Value[`${props.languageFormat}`]}
            </th>
          )}
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => {
          return (
            <tr
              data-row="ok"
              data-select={`sl${i}`}
              data-fix="ok"
              data-id={i}
              key={i}
              onClick={() => props.handleModal(item.responseId, 'reload', `sl${i}`)}
              className="hover"
            >
              {props.tableDate === 1 && (
                <td data-fix="ok" className="first left">
                  <span className={`bg${item.classification} font16`} />
                  {dateSelect(item, props.main)}
                </td>
              )}
              {props.tableDate === 2 && (
                <td data-fix="ok" className="first left">
                  <span className={`bg${item.classification} font16`} />
                  {dateSelect(item, 1)}
                </td>
              )}
              {props.tableDate === 2 && (
                <td data-fix="ok" className="left">
                  <span className={`bg${item.classification} font16`} />
                  {dateSelect(item, 2)}
                </td>
              )}
              <td data-fix="ok" className="left">
                {item.supervisor}
              </td>
              <td data-fix="ok" className={`center ${item.classification} font18`}>
                {item.score === null ? 'N/A' : item.score}
              </td>
              <td data-fix="ok" className="left">
                {item.type}
              </td>
              <td data-fix="ok" className="left">
                {item.formName}
              </td>
              <td data-fix="ok" className="left">
                {item.driver}{' '}
              </td>
              <td data-fix="ok" className="left">
                {item.equipment}
              </td>
              {validateFails(item.fails) ? (
                <td data-fix="ok" className="left">
                  {item.fails.map((fai, i) => (
                    <p
                      data-fix="ok"
                      key={i}
                      style={{
                        color: colorSeverity(props.severityFailsColor, fai.severityType)
                      }}
                    >
                      {fai.severityType.toUpperCase() === 'NONE'
                        ? ''
                        : validateFailsCount(fai, props.severityFailsColor, props.languageFormat)}
                    </p>
                  ))}
                </td>
              ) : (
                <td data-fix="ok" className="left">
                  <p
                    data-fix="ok"
                    style={{
                      color: '#41c99f'
                    }}
                  >
                    {props.language.summary.text.withFails}
                  </p>
                </td>
              )}
              {props.filterQuestion.filterQuestion1Value.state && (
                <td className="left" data-fix="ok">
                  {item.filterQuestion1Value}
                </td>
              )}
              {props.filterQuestion.filterQuestion2Value.state && (
                <td className="left" data-fix="ok">
                  {item.filterQuestion2Value}
                </td>
              )}
              {props.filterQuestion.filterQuestion3Value.state && (
                <td className="left" data-fix="ok">
                  {item.filterQuestion3Value}
                </td>
              )}
            </tr>
          );
        })}
      </tbody>
    </table>
    {props.loadingTable && (
      <div className="loading-table">
        <h6>
          <i className="fas fa-spinner fa-spin" />
        </h6>
      </div>
    )}
    {props.pag >= props.count.pages && (
      <div className="loading-table">
        <h6>{props.language.filter.nodata}</h6>
      </div>
    )}
  </div>
);
Table.propTypes = {
  pag: PropTypes.number.isRequired,
  count: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  loadingTable: PropTypes.bool.isRequired,
  language: PropTypes.oneOfType([PropTypes.object]).isRequired,
  datos: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object,
    PropTypes.array
  ]).isRequired
};
export default Table;



// WEBPACK FOOTER //
// ./source/client/components/summary_inspections/table.jsx